import { render, staticRenderFns } from "./rejected-leads.vue?vue&type=template&id=3869d768"
import script from "./rejected-leads.vue?vue&type=script&lang=js"
export * from "./rejected-leads.vue?vue&type=script&lang=js"
import style0 from "./rejected-leads.vue?vue&type=style&index=0&id=3869d768&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports